import { type StoredUser } from 'auth/domain/User'
import { type UserLogin } from 'auth/domain/UserLogin'

export type RawUserLogin = {
  jwt_token: string
  visual_token: string
  user: StoredUser
  captchaToken: string
}

export type RawLogin = {
  email: string
  password: string
}

export type TokenRequest = {
  auth_code: string
  code_verifier: string
}

export type TokenResponse = {
  access_token: string
  refresh_token: string
  user: StoredUser
}

export type OpenDockLoginRequest = {
  email: string
  password: string
  captchaToken: string
}

export type OpenDockUser = {
  email: string
  first_name: string
  last_name: string
  client: string
  issuer: string
  org_id?: string
}

export type OpenDockTokenResponse = {
  access_token: string
  expires_in: number
  user: OpenDockUser
}

export function mapApiToUserLogin(userLogin: RawUserLogin): UserLogin {
  return {
    accessToken: userLogin.jwt_token,
    visualToken: userLogin.visual_token,
    userLogin: userLogin.user,
    captchaToken: userLogin.captchaToken
  }
}

export function mapTokenApiToUserLogin(tokenResponse: TokenResponse): UserLogin {
  return {
    accessToken: tokenResponse.access_token,
    visualToken: "",
    userLogin: tokenResponse.user,
    captchaToken: "",
  }
}

export function mapOpenDockApiToUserLogin(tokenResponse: OpenDockTokenResponse): UserLogin {
  const userObject = {
    email: tokenResponse.user.email,
    first_name: tokenResponse.user.first_name || '',
    last_name: tokenResponse.user.last_name || '',
    client: tokenResponse.user.client,
    issuer: tokenResponse.user.issuer,
    org_id: tokenResponse.user.org_id,
  }

  return {
    accessToken: tokenResponse.access_token,
    visualToken: "",
    userLogin: userObject,
    captchaToken: "",
  }
}
